import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage.tsx';
import {rbacActions} from '../../config/rbac/actions.ts';

export const TestingActionsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListTestingActions}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action={rbacActions.CreateTestingAction}>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetTestingAction}>
                        <EditPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
